import {ReactNode} from 'react';
import ToggleV4 from './ToggleV4';
import SwitchToggleV4 from '../../../commonSub/component/SwitchToggleV4';
import {IToggleTypeV4} from '../type';

interface IProps {
  toggleType: IToggleTypeV4;
  showToggle?: boolean;
  isSelected: boolean;
  children: ReactNode;
}

export default function ToggleWithContentV4({
  toggleType,
  showToggle,
  isSelected,
  children,
}: IProps) {
  return (
    <>
      {showToggle && (
        <>
          {toggleType === 'checkbox' && <ToggleV4 isSelected={isSelected} />}
          {toggleType === 'slide' && (
            <SwitchToggleV4 size="small" isChecked={isSelected} />
          )}
        </>
      )}
      {!showToggle && children}
    </>
  );
}
